export const SET_STATE = 'checkoutPage/paymentKlarna/SET_STATE';
export const REQUEST_CUSTOMER = 'checkoutPage/paymentKlarna/REQUEST_CUSTOMER';
export const SET_FETCHING_PAYMENT = 'checkoutPage/paymentKlarna/SET_FETCHING_PAYMENT';
export const SET_CUSTOMER = 'checkoutPage/paymentKlarna/SET_CUSTOMER';
export const SET_PAYMENT = 'checkoutPage/paymentKlarna/SET_RESPONSE';
export const SET_AND_VALIDATE_INPUT_VALUE = 'checkoutPage/paymentKlarna/SET_AND_VALIDATE_INPUT_VALUE';
export const SET_INPUT_FIELD_VALIDITY = 'checkoutPage/paymentKlarna/SET_INPUT_FIELD_VALIDITY';
export const SET_INPUT_FIELD_VALIDATING = 'checkoutPage/paymentKlarna/SET_INPUT_FIELD_VALIDATING';
export const RESET_PAYMENT_KLARNA = 'checkoutPage/paymentKlarna/RESET_PAYMENT_KLARNA';
